<template>
  <div v-if="goalForm">
    <el-dialog
      :title="isNewGoal ? 'Create new goal' : 'Update goal: ' + goalForm.headline"
      :close-on-click-modal="false"
      :visible.sync="goalFormVisible"
      class="vb-goal-config-dialog"
      @close="onResetForm">

      <!-- TODO: Merge with graphicalRepresentation bzw. das kommt ja in sidebar -->

      <info-box title="What is a goal?">
        <img src="@/assets/flaticons/top.svg" height="64" style="float: right" />
        A <strong>Goal</strong> in Goalpilot is something BIG, that you or your team want to achive.
        You can think of a project or something that involes multiple steps or multiple people.
      </info-box>

      <el-form :model="goalForm" size="fat" label-position="top" @submit.native.prevent>
        <div style="display: flex">
          <el-form-item label="What is your goal?" class="w-100 pr-4">
            <el-autocomplete
              class="w-100"
              popper-class="el-popper--fat"
              v-model="goalForm.headline"
              clearable
              placeholder="Your new goal..."
              :fetch-suggestions="goalQuerySearch"
              autocomplete="off"
              autofocus />
          </el-form-item>

          <el-form-item label="Need some inspiration?">
            <el-button @click="onBrowseLibrary">Browse library</el-button>
          </el-form-item>
        </div>

        <!-- <ImageUpload v-model="goalForm.imageURL" bucket="goal_pics" /> -->

        <el-form-item label="Motto Picture">
          <image-selector-mini
            v-model="goalForm.imageURL"
            content="goal"
            bucket="goal_pics"
            :suggestion-text="null" />
        </el-form-item>

      </el-form>

      <div class="wizard-buttons pt-6">
        <el-button size="fat" type="primary" @click="updateGoalWithFormData" :disabled="!enable_create_button">
          {{ isNewGoal ? 'Create' : 'Update'}}
        </el-button>
        <el-button v-if="!isNewGoal" size="fat" type="danger" @click="deleteGoal">Delete Goal</el-button>
        <el-button v-if="!isNewGoal" @click="onGoToGoal" size="fat">Go to goal page</el-button>
      </div>

      <pre class="mini-pre" v-if="SHOW_DEBUG">{{goalForm}}</pre>
    </el-dialog>
  </div>
</template>

<script>
import FuseSearch from '@/components/Mixins/FuseSearch'

// TODO: Maybe we don't need a !isNewGoal option here, since we can always go to config page

export default {
  data: () => ({
    isNewGoal: true,
    goalId: null,
    goalForm: null,
    goalFormVisible: false,
    cached_goal_list: [],
  }),
  mixins: [ FuseSearch ],
  computed: {
    enable_create_button() {
      return !!this.goalForm.headline
    }
  },
  mounted() {
    // TODO: Wird immer beim start ausgeführt
    import("@/assets/content/goals.js").then(goals => {
      let goallist = goals.default;
      goallist = goallist.split('\n')
      goallist = goallist.filter(line => line.trim() !== '' && line[0] !== '#')
      goallist = goallist.map(line => ({ value: line }))
      this.cached_goal_list = goallist;
      // console.log("goallist", goallist)

      this.makeSearchCache();
      this.setUpFuse({ keys: [ "value" ] }, false, false);
    })
  },
  methods: {
    makeSearchCache() {
      this.search_cache = this.cached_goal_list;
    },

    showNewModal({ isTeamgoal, categoryId }) {
      console.log("showGoalUpdateForm" );
      this.isNewGoal = true;
      this.goalId = null;
      this.goalForm = {
        headline: '',
        imageURL: '',
        image: {},
        isTeamgoal: isTeamgoal,
        categoryId: categoryId,
      };
      this.goalFormVisible = true;
    },

    showUpdateModal({ goalId }) {
      console.log("showGoalUpdateForm", goalId );
      let publicGoal = this.$models.goalMeta.getNode( goalId, { mustBeReady /* TODO */: true } );

      // TODO: Check if ready
      console.log("publicGoal", publicGoal);

      this.isNewGoal = false;
      this.goalId = goalId;
      this.goalForm = {
        headline: publicGoal.name,
        imageURL: publicGoal.picture,
        image: {},
        // isTeamgoal: publicGoal.isTeamgoal,
      };
      this.goalFormVisible = true;
    },

    onResetForm() {
      console.log("onResetForm");
      this.isNewGoal = true;
      this.goalId = null;
      this.goalForm = null;
    },

    updateGoalWithFormData() {

      if ( this.isNewGoal ) {

        this.$api.goal_create({
          name:       this.goalForm.headline,
          picture:    this.goalForm.imageURL,
          isTeamgoal: this.goalForm.isTeamgoal,
          dataUser: {
            categoryId: this.goalForm.categoryId,
          },
        }).then(() => {
          this.$emit('saved', this.goalForm);
        })

      } else {
        let promiseUpdate = this.$api.goal_update({
          goal_id: this.goalId,
          data: {
            // name:    this.goalForm.headline,
            picture: this.goalForm.imageURL
          }
        });

        let promiseTitle = this.$api.goal_update_name({
          goal_id: this.goalId,
          title:   this.goalForm.headline
        });

        Promise.all([promiseUpdate, promiseTitle]).then(() => {
          this.$emit('saved', this.goalForm);
        });
        // this.update_user_goal({ data, goal_id }) --> ?
      }

      // var goalIndex = this.getIndexForGoalId(goalId);
      // this.goals[goalIndex].headline.text = this.goalForm.headline;
      // update image information

      this.goalFormVisible = false;
    },

    deleteGoal() {
      if ( !this.isNewGoal ) {
        this.$api.goal_delete({ goal_id: this.goalId }).then(() => {
          this.$emit('deleted');
        })
      }
      this.goalFormVisible = false;
    },

    onGoToGoal() {
      this.goalFormVisible = false;
      this.$router.push('/goal/' + this.goalId);
    },

    goalQuerySearch(queryString, cb) {
      this.querySearch(queryString, result => {
        cb( result.slice(0, 25) )
      })
    },

    onBrowseLibrary() {
      this.goalFormVisible = false;
      this.$router.push('/challenges')
    },
  },
}
</script>

<style>
.vb-goal-config-dialog h4 {
  margin-top: 0;
  max-width: 600px;
}
</style>
